import { render, staticRenderFns } from "./UniverseSelectorModal.vue?vue&type=template&id=77de6a09"
import script from "./UniverseSelectorModal.vue?vue&type=script&lang=ts"
export * from "./UniverseSelectorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports